// Fiches techniques des 3 contrôleurs inclus dans les kits (source : fabricant GFLAI)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CONTROLLER_IMAGES = {
  mini: `${BACKEND_URL}/api/uploads/controller-mini.jpg`,
  mobile: `${BACKEND_URL}/api/uploads/controller-mobile.jpg`,
  pro: `${BACKEND_URL}/api/uploads/controller-pro.jpg`,
};

export const MARKING_IMAGE = `${BACKEND_URL}/api/uploads/marking-zone.png`;

export const SPEC_LABELS = {
  fr: {
    sheet: 'Fiche technique', specs: 'Caractéristiques', functions: 'Fonctions',
    range: 'Portée', frequency: 'Fréquence', capacity: 'Bracelets pilotés',
    battery: 'Batterie', power: 'Alimentation', size: 'Dimensions',
    colors: 'Couleurs', flash: 'Vitesses de clignotement', effects: 'Effets lumineux',
    control: 'Pilotage', viewSheet: 'Voir la fiche technique', close: 'Fermer',
    markingTitle: 'Zone de marquage', markingSub: 'Marquage en 1 couleur inclus dans chaque kit',
    markingNote: 'Votre logo, vos prénoms ou votre date sont imprimés sur la face supérieure du bracelet, dans une zone de 35 mm × 18 mm. Envoyez-nous votre fichier vectoriel (AI, EPS, PDF) ou une image haute résolution : nous validons le rendu avec vous avant production.',
    viewMarking: 'Voir la zone de marquage',
    pickController: 'Choisissez votre contrôleur', pickControllerSub: '1 contrôleur inclus dans chaque kit — cliquez pour voir la fiche',
    material: 'Matériau', leds: 'LED', autonomy: 'Autonomie', marking: 'Zone de marquage', nfc: 'Puce NFC', water: 'Résistance à l\'eau', closure: 'Fermeture', braceletSheet: 'Fiche technique du bracelet', viewBracelet: 'Voir la fiche technique du bracelet',
  },
  en: {
    sheet: 'Technical sheet', specs: 'Specifications', functions: 'Functions',
    range: 'Range', frequency: 'Frequency', capacity: 'Wristbands controlled',
    battery: 'Battery', power: 'Power supply', size: 'Dimensions',
    colors: 'Colours', flash: 'Flash speeds', effects: 'Light effects',
    control: 'Control', viewSheet: 'View technical sheet', close: 'Close',
    markingTitle: 'Branding area', markingSub: 'One-colour branding included in every kit',
    markingNote: 'Your logo, names or date are printed on the top face of the wristband, within a 35 mm × 18 mm area. Send us a vector file (AI, EPS, PDF) or a high-resolution image: we validate the artwork with you before production.',
    viewMarking: 'View branding area',
    pickController: 'Choose your controller', pickControllerSub: 'One controller included in every kit — tap to open its sheet',
    material: 'Material', leds: 'LEDs', autonomy: 'Battery life', marking: 'Branding area', nfc: 'NFC chip', water: 'Water resistance', closure: 'Fastening', braceletSheet: 'Wristband technical sheet', viewBracelet: 'View the wristband technical sheet',
  },
  ar: {
    sheet: 'الورقة التقنية', specs: 'المواصفات', functions: 'الوظائف',
    range: 'المدى', frequency: 'الترددد', capacity: 'عدد الأسورة المتحكم بها',
    battery: 'البطارية', power: 'التغذية الكهربائية', size: 'الأبعاد',
    colors: 'الألوان', flash: 'سرعات الوميض', effects: 'المؤثرات الضوئية',
    control: 'التحكم', viewSheet: 'عرض الورقة التقنية', close: 'إغلاق',
    markingTitle: 'منطقة الطباعة', markingSub: 'الطباعة بلون واحد مشمولة في كل طقم',
    markingNote: 'يُطبع شعارك أو الأسماء أو التاريخ على الوجه العلوي للسوار، داخل مساحة 35 مم × 18 مم. أرسل لنا ملفًا متجهيًا (AI، EPS، PDF) أو صورة بدقة عالية: نؤكد التصميم معك قبل الإنتاج.',
    viewMarking: 'عرض منطقة الطباعة',
    pickController: 'اختر وحدة التحكم', pickControllerSub: 'وحدة تحكم واحدة مشمولة في كل طقم — اضغط لعرض الورقة التقنية',
    material: 'المادة', leds: 'مصابيح LED', autonomy: 'مدة التشغيل', marking: 'منطقة الطباعة', nfc: 'شريحة NFC', water: 'مقاومة الماء', closure: 'الإغلاق', braceletSheet: 'الورقة التقنية للسوار', viewBracelet: 'عرض الورقة التقنية للسوار',
  },
  it: {
    sheet: 'Scheda tecnica', specs: 'Caratteristiche', functions: 'Funzioni',
    range: 'Portata', frequency: 'Frequenza', capacity: 'Bracciali controllati',
    battery: 'Batteria', power: 'Alimentazione', size: 'Dimensioni',
    colors: 'Colori', flash: 'Velocità di lampeggio', effects: 'Effetti luminosi',
    control: 'Controllo', viewSheet: 'Vedi la scheda tecnica', close: 'Chiudi',
    markingTitle: 'Area di stampa', markingSub: 'Stampa in un colore inclusa in ogni kit',
    markingNote: 'Il tuo logo, i nomi o la data vengono stampati sulla faccia superiore del bracciale, in un\'area di 35 mm × 18 mm. Inviaci un file vettoriale (AI, EPS, PDF) o un\'immagine ad alta risoluzione: validiamo la grafica con te prima della produzione.',
    viewMarking: 'Vedi l\'area di stampa',
    pickController: 'Scegli il tuo controller', pickControllerSub: 'Un controller incluso in ogni kit — clicca per vedere la scheda',
    material: 'Materiale', leds: 'LED', autonomy: 'Autonomia', marking: 'Area di stampa', nfc: 'Chip NFC', water: 'Resistenza all\'acqua', closure: 'Chiusura', braceletSheet: 'Scheda tecnica del bracciale', viewBracelet: 'Vedi la scheda tecnica del bracciale',
  },
};

const CONTROL_MODES = {
  mini: {
    fr: 'Télécommande de poche, 13 touches',
    en: 'Handheld remote, 13 keys',
    ar: 'جهاز تحكم يدوي، 13 مفتاحًا',
    it: 'Telecomando portatile, 13 tasti',
  },
  mobile: {
    fr: 'Application « RF Fun » sur smartphone ou tablette (iOS / Android)',
    en: '"RF Fun" app on smartphone or tablet (iOS / Android)',
    ar: 'تطبيق «RF Fun» على الهاتف أو الجهاز اللوحي (iOS / Android)',
    it: 'App « RF Fun » su smartphone o tablet (iOS / Android)',
  },
  pro: {
    fr: 'Ordinateur + logiciel de pilotage (Windows / macOS) ou application mobile',
    en: 'Computer + control software (Windows / macOS) or mobile app',
    ar: 'كمبيوتر + برنامج التحكم (Windows / macOS) أو تطبيق الهاتف',
    it: 'Computer + software di controllo (Windows / macOS) o app mobile',
  },
};

const FUNCTIONS = {
  mini: {
    fr: ['Prise en main immédiate, aucune installation', 'Format de poche, léger et rechargeable', 'Idéal jusqu\'à 200 personnes'],
    en: ['Instant to use, no installation', 'Pocket size, light and rechargeable', 'Ideal up to 200 people'],
    ar: ['استخدام فوري بدون تركيب', 'حجم الجيب، خفيف وقابل للشحن', 'مثالي حتى 200 شخص'],
    it: ['Immediato da usare, nessuna installazione', 'Formato tascabile, leggero e ricaricabile', 'Ideale fino a 200 persone'],
  },
  mobile: {
    fr: ['Contrôle par zones depuis votre téléphone', 'Contrôle audio : la lumière suit la musique', 'Votre DJ pilote depuis la platine'],
    en: ['Zone control from your phone', 'Audio control: light follows the music', 'Your DJ drives it from the decks'],
    ar: ['تحكم بالمناطق من هاتفك', 'تحكم صوتي: الضوء يتبع الموسيقى', 'منسق الأغاني يتحكم من مكانه'],
    it: ['Controllo a zone dal telefono', 'Controllo audio: la luce segue la musica', 'Il tuo DJ lo gestisce dalla consolle'],
  },
  pro: {
    fr: ['Jusqu\'à 10 groupes de bracelets pilotés séparément', 'Effets programmés et synchronisés à la timeline du show', 'Puissance du signal réglable sur 6 niveaux'],
    en: ['Up to 10 wristband groups driven separately', 'Effects programmed and synced to the show timeline', 'Signal power adjustable over 6 levels'],
    ar: ['حتى 10 مجموعات أسورة يتم التحكم بها بشكل منفصل', 'مؤثرات مبرمجة ومتزامنة مع خط زمن العرض', 'قوة الإشارة قابلة للتعديل على 6 مستويات'],
    it: ['Fino a 10 gruppi di bracciali gestiti separatamente', 'Effetti programmati e sincronizzati alla timeline dello show', 'Potenza del segnale regolabile su 6 livelli'],
  },
};

export const CONTROLLER_SPECS = {
  mini: {
    ref: 'GFC004',
    image: CONTROLLER_IMAGES.mini,
    rows: [
      ['range', '150 – 200 m'],
      ['frequency', '433 MHz'],
      ['capacity', '10 000+'],
      ['battery', '3,7 V / 3000 mAh (Li-ion)'],
      ['size', '12,5 × 8 × 2,2 cm'],
      ['colors', '7'],
      ['flash', '5'],
    ],
    control: CONTROL_MODES.mini,
    functions: FUNCTIONS.mini,
  },
  mobile: {
    ref: 'GFC008',
    image: CONTROLLER_IMAGES.mobile,
    rows: [
      ['range', '150 – 200 m'],
      ['frequency', '433 MHz'],
      ['capacity', '10 000+'],
      ['battery', '3,7 V / 3000 mAh (Li-ion)'],
      ['size', '9,8 × 7,5 × 4 cm'],
      ['colors', '15'],
      ['flash', '5'],
      ['effects', '19'],
    ],
    control: CONTROL_MODES.mobile,
    functions: FUNCTIONS.mobile,
  },
  pro: {
    ref: 'GFC007',
    image: CONTROLLER_IMAGES.pro,
    rows: [
      ['range', '150 – 200 m'],
      ['frequency', '433 MHz'],
      ['capacity', '10 000+'],
      ['power', '6 V / 1 A'],
      ['size', '21 × 15 × 6 cm'],
      ['colors', '16 581 375'],
      ['effects', '19'],
    ],
    control: CONTROL_MODES.pro,
    functions: FUNCTIONS.pro,
  },
};

// Fiche technique du bracelet LED (modèle GFB009, source : fabricant GFLAI)
export const BRACELET_SPEC = {
  ref: 'GFB009',
  rows: [
    ['leds', '2 × RGB'],
    ['colors', '16 581 375'],
    ['battery', '2 × CR2032'],
    ['autonomy', '≈ 10 h'],
    ['frequency', '433 MHz (RF)'],
    ['range', '150 – 200 m'],
    ['capacity', '10 000+'],
    ['marking', '35 × 18 mm'],
  ],
  material: {
    fr: 'Polypropylène — coque blanche translucide',
    en: 'Polypropylene — translucent white shell',
    ar: 'بولي بروبيلين — هيكل أبيض شبه شفاف',
    it: 'Polipropilene — scocca bianca traslucida',
  },
  water: {
    fr: 'Résistant aux éclaboussures et à la transpiration. Ne pas immerger.',
    en: 'Resistant to splashes and perspiration. Do not immerse.',
    ar: 'مقاوم للرشاش والعرق. لا يُغمر في الماء.',
    it: 'Resistente a schizzi e sudore. Non immergere.',
  },
  functions: {
    fr: [
      'Retirez la languette de protection de la pile : le bracelet s\'allume et se synchronise seul avec tous les autres.',
      'Piles CR2032 remplaçables : le même bracelet sert sur 2 à 3 événements avant changement.',
      'Bracelet réglable, taille unique adulte et enfant, fermeture à cliquet.',
      'Puce NFC incluse : un téléphone approché du bracelet ouvre l\'URL de votre choix.',
      'Marquage en 1 couleur offert dans une zone de 35 × 18 mm sur la face supérieure.',
    ],
    en: [
      'Pull the battery protection tab: the wristband switches on and syncs by itself with all the others.',
      'Replaceable CR2032 cells: the same wristband covers 2 to 3 events before a swap.',
      'Adjustable strap, one size for adults and children, ratchet fastening.',
      'NFC chip included: a phone tapped on the wristband opens the URL of your choice.',
      'One-colour branding included in a 35 × 18 mm area on the top face.',
    ],
    ar: [
      'اسحب لسان حماية البطارية: يضيء السوار ويتزامن تلقائيًا مع جميع الأسورة الأخرى.',
      'بطاريات CR2032 قابلة للاستبدال: السوار نفسه يكفي لـ 2 إلى 3 فعاليات قبل التغيير.',
      'سوار قابل للتعديل، مقاس واحد للبالغين والأطفال، إغلاق بمشبك.',
      'شريحة NFC مدمجة: تقريب الهاتف من السوار يفتح الرابط الذي تختاره.',
      'طباعة بلون واحد مجانًا في مساحة 35 × 18 مم على الوجه العلوي.',
    ],
    it: [
      'Togli la linguetta di protezione della batteria: il bracciale si accende e si sincronizza da solo con tutti gli altri.',
      'Batterie CR2032 sostituibili: lo stesso bracciale copre da 2 a 3 eventi prima del cambio.',
      'Cinturino regolabile, taglia unica adulti e bambini, chiusura a scatto.',
      'Chip NFC incluso: avvicinando il telefono si apre l\'URL che preferisci.',
      'Stampa in un colore inclusa in un\'area di 35 × 18 mm sulla faccia superiore.',
    ],
  },
};
